/* eslint-disable */
// Bilingual dictionary — Spanish (default) + English
// Tono: claro, humano, directo. Pensamos en el cliente que entra por
// primera vez y necesita entender QUÉ HACEMOS, QUÉ GANA y CÓMO OPERAMOS.

// SEO meta per locale (used by App.js to update <title> and <meta description>)
export const seo = {
  es: {
    title: "Incubatour Experiences Lab — Misiones empresariales, académicas y tecnológicas en Iberoamérica",
    description: "Diseñamos y operamos misiones empresariales, académicas y tecnológicas, ferias internacionales y representaciones de destino en Colombia, México, España y +5 mercados. Más de 25 años, +570 eventos operados. DMC · RNT 278668.",
    ogTitle: "Incubatour Experiences Lab — Misiones B2B y representaciones turísticas",
    ogDescription: "Misiones empresariales, académicas y tecnológicas. Representación de destinos en IBTM, FITUR, ANATO, ITB, Tianguis y WTM. DMC con RNT 278668 desde Colombia.",
  },
  en: {
    title: "Incubatour Experiences Lab — Commercial, academic and technical missions in Ibero-America",
    description: "We design and operate commercial, academic and technical missions, international fairs and destination representation across Colombia, Mexico, Spain and +5 markets. 25+ years, +570 events operated. DMC · RNT 278668.",
    ogTitle: "Incubatour Experiences Lab — B2B missions and destination representation",
    ogDescription: "Commercial, academic and technical missions. Destination representation at IBTM, FITUR, ANATO, ITB, Tianguis and WTM. DMC with RNT 278668 from Colombia.",
  },
};

export const dict = {
  es: {
    nav: {
      lineas: "Misiones",
      diferencial: "Por qué nosotros",
      cobertura: "Mercados",
      proceso: "Compromisos",
      contacto: "Contacto",
      whatsapp: "WhatsApp",
    },
    hero: {
      eyebrow: "Una iniciativa de Incubatour",
      title_a: "Misiones que conectan",
      title_b: "empresas, gremios y territorios",
      title_c: "con resultados.",
      sub: "Diseñamos y operamos misiones empresariales, académicas y tecnológicas, además de ferias y representaciones turísticas en Iberoamérica. Las misiones son estrategia: promueven, comercializan y aceleran la inmersión en mercados nuevos o por consolidar — para atraer turismo, abrir negocios y aprender de los referentes.",
      cta_primary: "Hablar por WhatsApp",
      cta_secondary: "Ver qué hacemos",
      trust: "Operamos desde Colombia · RNT 278668",
      scroll: "Desliza",
      upcoming_eyebrow: "Próxima agenda",
      upcoming_title: "Próximas misiones",
      upcoming_hint: "Pregunta por cupos, representación o cómo participar",
      upcoming_cta: "Preguntar",
      upcoming_footnote: "Te respondemos por WhatsApp en menos de 24 h",
    },
    manifesto: {
      eyebrow: "Manifiesto",
      lead: "Las misiones no son viajes. Son estrategia.",
      paragraph_1: "Promueven destinos, comercializan productos turísticos y aceleran la inmersión de empresas, gremios e instituciones en mercados nuevos o por consolidar.",
      paragraph_2: "Incubatour Experiences Lab nace de los más de 25 años que llevamos diseñando y operando misiones empresariales, académicas y tecnológicas, ferias internacionales y representación de destinos en Iberoamérica. Convertimos ese conocimiento en misiones que atraen turismo, abren negocios y dejan aprendizajes accionables.",
    },
    lineas: {
      eyebrow: "Lo que hacemos",
      title: "Tres tipos de misiones, un mismo método.",
      subtitle: "Promoción, comercialización y aprendizaje. Las misiones aceleran la inmersión en un mercado nuevo o por consolidar — para atraer turismo, abrir negocios y conocer a los referentes en persona.",
      explore: "Ver más",
      misiones: {
        tag: "Servicios",
        audience: "Para empresas, gremios e instituciones",
        title: "Misiones, ferias y representaciones",
        subtitle: "Estrategia operada en terreno para promocionar, comercializar y aprender.",
        description: "Para empresas, gremios e instituciones que quieren entrar a un mercado nuevo, consolidar uno existente o atraer turismo hacia su destino. Diseñamos y operamos la misión completa, la representación en feria o solo la parte estratégica — tú eliges hasta dónde llegamos.",
        anti: "No son viajes institucionales. Son estrategias con resultados que puedes reportar.",
        benefits_label: "Qué ganas",
        benefits: [
          "Inserción real en el mercado — reuniones con quien decide, no con intermediarios",
          "Promoción y comercialización directa de tu destino, producto o gremio",
          "Visitas técnicas a empresas y operaciones referentes — aprendizaje en el terreno",
          "Operación de stand y representación en ferias internacionales",
          "Networking con mayoristas, autoridades y aliados que mueven la aguja",
          "Reporte ejecutivo con contactos, hallazgos y oportunidades accionables",
        ],
        operation_label: "Cómo operamos",
        operation: [
          "Tú decides hasta dónde llegamos: solo agenda, operación de stand, o agenda + logística completa (vuelos, hospedaje, traslados, facilitación, RRPP, activaciones).",
          "Concepto creativo, activaciones, relaciones públicas y agendas institucionales — todo lo que necesita un destino o empresa para destacar.",
          "Coordinación de principio a fin — sin que tengas que perseguir a nadie.",
        ],
        flagship_label: "Producto estrella",
        flagship: "Misiones académicas con inmersión real: tu equipo aprende dentro de empresas, destinos y operaciones líderes — con expertos del sector facilitando cada visita. No clases magistrales, no auditorios. Aprendizaje en el terreno.",
        types_label: "Tres tipos de misiones",
        types: [
          {
            code: "01",
            name: "Empresariales",
            tag: "B2B · Comerciales",
            description: "Misiones para conectar tu empresa o gremio con mercados, distribuidores, mayoristas y aliados estratégicos. Reuniones reales con quien decide, no con intermediarios.",
            cta: "Diseñar misión empresarial",
          },
          {
            code: "02",
            name: "Académicas",
            tag: "Inmersión · Aprendizaje",
            description: "Tu equipo aprende dentro de empresas, destinos y operaciones líderes — con expertos del sector facilitando cada visita. Aprendizaje en el terreno, no en auditorios.",
            cta: "Diseñar misión académica",
            flagship: true,
          },
          {
            code: "03",
            name: "Tecnológicas",
            tag: "Innovación · Benchmarks",
            description: "Misiones técnicas para conocer de primera mano cómo operan los referentes en innovación, infraestructura, tecnología aplicada y nuevos modelos de negocio del sector.",
            cta: "Diseñar misión tecnológica",
          },
        ],
        formats_label: "Formatos",
        formats: ["Comerciales", "Académicas", "Técnicas", "Corporativas", "Ferias internacionales", "Representaciones de destino"],
        events_label: "Hemos operado en",
        events: [
          "Tianguis Turístico — México",
          "FITUR — Madrid, España",
          "IBTM Américas — México",
          "ITB — Berlín, Alemania",
          "Convening Latam",
          "WTM — Londres, Reino Unido",
        ],
        results_label: "Resultados que entregamos",
        results: [
          "+15 reuniones de negocio por actor invitado",
          "Reuniones con autoridades europeas, mexicanas y colombianas",
          "Mayoristas, empresas de alto nivel y aliados estratégicos en la mesa",
          "Inserción real en el mercado — no solo presencia en el stand",
        ],
        cta: "Diseñar mi misión",
      },
      transformadoras: {
        tag: "Línea 02",
        audience: "Para equipos, líderes y emprendedores",
        title: "Experiencias Transformadoras",
        subtitle: "Para cuando tu equipo, tu liderazgo o tú necesitan parar y volver con claridad.",
        description: "Cuando las decisiones llevan meses sin tomarse, el equipo está agotado o el liderazgo necesita aire. Diseñamos retiros que combinan territorio, naturaleza y facilitación experta — y que se notan al regresar.",
        anti: "No es un retiro de bienestar más. Es un punto de inflexión.",
        benefits_label: "Qué ganas",
        benefits: [
          "Un espacio diseñado para tomar la decisión que llevas posponiendo",
          "Reconexión real con tu equipo, no actividades para Instagram",
          "Facilitadores con experiencia comprobada, no charlas motivacionales",
          "Naturaleza y experiencias que tu equipo recordará por años",
          "Un grupo más alineado y con energía nueva al volver",
        ],
        operation_label: "Cómo operamos",
        operation: [
          "Conversación previa para entender el momento que vives o que vive tu equipo.",
          "Diseño 100% a la medida: lugar, agenda, facilitadores y ritmo.",
          "Acompañamiento durante toda la experiencia, sin sorpresas.",
        ],
        formats_label: "Enfoques",
        formats: ["Liderazgo", "Bienestar", "Naturaleza", "Co-creación", "Reflexión"],
        cta: "Diseñar mi experiencia",
      },
      curados: {
        tag: "Línea 03",
        audience: "Para viajeros con criterio",
        title: "Viajes a la medida",
        subtitle: "Para quienes ya viajaron 'lo típico' y ahora quieren algo que valga el tiempo.",
        description: "Diseñamos contigo un viaje que combina cultura, naturaleza, gastronomía, arte o patrimonio — con anfitriones, lugares y experiencias que no aparecen en buscadores. Tu agenda, tu ritmo, tus intereses reales.",
        anti: "No vendemos paquetes. Cada viaje se diseña contigo.",
        benefits_label: "Qué ganas",
        benefits: [
          "Un viaje hecho a tu medida, con detalles que normalmente solo entiende un local",
          "Acceso a anfitriones, chefs y artistas que no encuentras online",
          "Cero filas, cero buses turísticos, cero 'tienda obligatoria'",
          "Una persona dedicada que conoce tu viaje al detalle",
          "La sensación de haber visto el destino por dentro, no de pasada",
        ],
        operation_label: "Cómo operamos",
        operation: [
          "Llamada inicial para entender qué te emociona realmente.",
          "Propuesta personalizada con itinerario, alternativas y presupuesto claro.",
          "Coordinación completa desde tu casa hasta el regreso.",
        ],
        formats_label: "Universos",
        formats: ["Cultura", "Naturaleza", "Gastronomía", "Arte", "Patrimonio"],
        cta: "Diseñar mi viaje",
      },
    },
    marketplace: {
      eyebrow: "Próximamente",
      title: "Un marketplace de experiencias y aliados, en construcción.",
      lead: "Estamos creando un espacio para conectar viajeros, empresas y aliados con experiencias que ya conocemos, probamos y respaldamos.",
      categories_title: "Lo que vas a encontrar",
      categories: [
        { title: "Misiones", desc: "Experiencias profesionales con agenda diseñada." },
        { title: "Experiencias transformadoras", desc: "Retiros y programas con propósito." },
        { title: "Viajes a la medida", desc: "Itinerarios privados, hechos contigo." },
        { title: "Aliados locales", desc: "Operadores, anfitriones y especialistas que conocemos en persona." },
        { title: "Experiencias por destino", desc: "Rutas y programas por territorio." },
        { title: "Programas corporativos", desc: "Pensados para equipos e instituciones." },
      ],
      cta_primary: "Quiero ver las experiencias disponibles",
      cta_secondary: "Quiero ser aliado referido",
      note: "Cada categoría se llenará con experiencias y aliados que conocemos en persona. Nada de catálogos genéricos.",
    },
    diferencial: {
      eyebrow: "Por qué nosotros",
      title: "Conocemos el terreno.",
      lead: "Incubatour Experiences Lab nace de más de 25 años de experiencia acompañando procesos de transformación turística en Iberoamérica desde la consultoría, la innovación y el diseño de experiencias.",
      body: "En 25 años hemos operado más de 570 misiones, ferias y representaciones turísticas junto a empresas, instituciones y gremios. Conocemos qué funciona y qué no — porque lo hemos visto pasar en el terreno. No vendemos catálogo: probamos, validamos y operamos cada misión con equipo propio.",
      points: [
        "Experiencia real en el territorio, no desde el escritorio",
        "Conocimiento profundo del ecosistema turístico",
        "Red de aliados en Latinoamérica y Europa",
        "Mirada estratégica, no solo operativa",
        "Selección basada en confianza y propósito",
        "IA aplicada: matchmaking, generación de contactos, analítica y reportes en tiempo real",
      ],
      metrics: [
        { value: "+570", unit: "eventos", label: "operados en Iberoamérica · ferias, congresos, misiones y formativos" },
        { value: "+25", unit: "años", label: "acompañando al sector turístico en Iberoamérica" },
        { value: "+100", unit: "", label: "productos turísticos diseñados, validados o asesorados" },
        { value: "RNT", unit: "278668", label: "Operación legal en Colombia · Latinoamérica y Europa" },
      ],
      clients_eyebrow: "Han confiado en nosotros",
      clients: [
        "Anato — Capítulo Eje Cafetero",
        "ProColombia",
        "Secretaría de Turismo de Michoacán",
        "Buró de Medellín",
        "Comfama",
        "Alcaldía de Pereira",
        "Alcaldía de Santa Rosa de Cabal",
      ],
    },
    cobertura: {
      eyebrow: "Mercados internacionales operados",
      title: "Diseñamos donde realmente conocemos.",
      lead: "No vendemos destinos al azar. Activamos experiencias donde tenemos equipo, aliados y conocimiento de primera mano. Hemos operado en 8 mercados clave para conectar a Iberoamérica con el mundo.",
      markets_label: "Mercados con los que hemos trabajado",
      markets: [
        { code: "MX", name: "México" },
        { code: "ES", name: "España" },
        { code: "DE", name: "Alemania" },
        { code: "UK", name: "Reino Unido" },
        { code: "SV", name: "El Salvador" },
        { code: "UY", name: "Uruguay" },
        { code: "PA", name: "Panamá" },
        { code: "EC", name: "Ecuador" },
      ],
      fairs_label: "Ferias y eventos en los que hemos operado",
      fairs: [
        "Tianguis Turístico — México",
        "FITUR — Madrid, España",
        "IBTM Américas — México",
        "ITB — Berlín, Alemania",
        "Convening Latam",
        "WTM — Londres, Reino Unido",
      ],
      destinations: [
        { code: "CO", name: "Colombia", note: "Sede principal · territorio madre" },
        { code: "MX", name: "México", note: "Cultura, gastronomía y comunidad" },
        { code: "ES", name: "España", note: "Puente Europa–Iberoamérica" },
        { code: "GL", name: "Expediciones globales", note: "Con aliados de confianza" },
      ],
    },
    proceso: {
      eyebrow: "Garantías DMC",
      title: "Por eso somos DMC, no agencia.",
      steps: [
        { n: "01", t: "Equipo propio en destino", d: "Operamos directo en Colombia, México y España con personas nuestras. Sin subcontratistas en frío." },
        { n: "02", t: "Red validada en persona", d: "Hospedajes, traslados y aliados que probamos en +570 eventos. Nada de catálogo." },
        { n: "03", t: "Operación 100% legal", d: "RNT 278668, seguros, contratos y trazabilidad financiera de extremo a extremo." },
        { n: "04", t: "Reporte ejecutivo post-viaje", d: "Resultados, contactos y aprendizajes accionables para que tu inversión deje huella." },
      ],
    },
    audiencia: {
      eyebrow: "Para quién",
      title: "Tres mundos, un mismo cuidado.",
      list: [
        { t: "Empresas con propósito", d: "Que quieren diseñar viajes corporativos con impacto real, no solo eventos." },
        { t: "Instituciones y gremios", d: "Que necesitan misiones técnicas, comerciales o académicas con resultados." },
        { t: "Líderes y emprendedores", d: "Que buscan claridad, bienestar y visión a través del territorio." },
        { t: "Viajeros con criterio", d: "Que prefieren experiencias auténticas y profundas a paquetes genéricos." },
        { t: "Comunidades y destinos", d: "Que quieren conectar su oferta con públicos que de verdad la valoren." },
      ],
    },
    finalCta: {
      eyebrow: "Empecemos",
      title: "Cuéntanos qué misión quieres diseñar.",
      sub: "Una misión empresarial, académica o tecnológica. Una feria. Una representación de destino. Convertimos tu intención en una estrategia operada en terreno.",
      primary: "Hablar por WhatsApp",
      secondary: "Ver qué hacemos",
      footnote: "Operamos desde Colombia · RNT 278668 · Una iniciativa de Incubatour",
    },
    footer: {
      tagline: "Diseñamos y operamos misiones, ferias y representaciones turísticas en Iberoamérica.",
      nav_title: "Navegación",
      legal_title: "Legal",
      contact_title: "Contacto",
      copyright: "© {year} Incubatour Experiences Lab. Una iniciativa de Incubatour.",
      rnt: "RNT 278668",
      privacy: "Política de privacidad",
      terms: "Términos",
      social: "Redes sociales",
    },
    forms: {
      contact_title: "Diseñemos tu misión",
      contact_sub: "Cuéntanos qué necesitas. Te respondemos en menos de 24 horas hábiles.",
      referral_title: "Quiero ser aliado referido",
      referral_sub: "Comparte tu propuesta. Cada aliado lo conocemos antes de recomendarlo.",
      name: "Nombre completo",
      email: "Correo electrónico",
      phone: "Teléfono o WhatsApp",
      organization: "Organización",
      interest: "¿Qué te interesa?",
      interest_options: {
        mision: "Misión",
        transformadora: "Experiencia transformadora",
        curado: "Viaje a la medida",
        aliado: "Ser aliado",
        general: "Otra consulta",
      },
      category: "Categoría",
      category_options: {
        experiencia: "Experiencia",
        aliado: "Aliado / Operador",
        proveedor: "Proveedor especializado",
        destino: "Destino o territorio",
      },
      territory: "Territorio o destino",
      website: "Sitio web (opcional)",
      message: "Cuéntanos tu intención",
      description: "Descripción de tu propuesta",
      submit: "Enviar",
      sending: "Enviando…",
      success: "Recibimos tu mensaje. Te contactaremos pronto.",
      success_referral: "Recibimos tu propuesta. La revisaremos con atención.",
      error: "Hubo un error. Inténtalo de nuevo o escríbenos por WhatsApp.",
    },
  },
  en: {
    nav: {
      lineas: "Missions",
      diferencial: "Why us",
      cobertura: "Markets",
      proceso: "Commitments",
      contacto: "Contact",
      whatsapp: "WhatsApp",
    },
    hero: {
      eyebrow: "An Incubatour initiative",
      title_a: "Missions that connect",
      title_b: "companies, guilds and territories",
      title_c: "with results.",
      sub: "We design and operate commercial, academic and technical missions, plus fairs and destination representation across Ibero-America. Missions are strategy: they promote, commercialize and accelerate market entry in new or consolidating markets — to attract tourism, open business and learn from industry leaders.",
      cta_primary: "Talk on WhatsApp",
      cta_secondary: "See what we do",
      trust: "Based in Colombia · RNT 278668",
      scroll: "Scroll",
      upcoming_eyebrow: "Next agenda",
      upcoming_title: "Upcoming missions",
      upcoming_hint: "Ask about seats, representation or how to participate",
      upcoming_cta: "Ask",
      upcoming_footnote: "We reply on WhatsApp within 24 h",
    },
    manifesto: {
      eyebrow: "Manifesto",
      lead: "Missions are not trips. They are strategy.",
      paragraph_1: "They promote destinations, commercialize tourism products and accelerate market entry for companies, guilds and institutions in new or consolidating markets.",
      paragraph_2: "Incubatour Experiences Lab grows from over 25 years designing and operating commercial, academic and technical missions, international fairs and destination representation across Ibero-America. We turn that knowledge into missions that attract tourism, open business and leave actionable learnings.",
    },
    lineas: {
      eyebrow: "What we do",
      title: "Three mission types, one method.",
      subtitle: "Promotion, commercialization and learning. Missions accelerate market entry into new or consolidating markets — to attract tourism, open business and meet industry leaders in person.",
      explore: "See more",
      misiones: {
        tag: "Services",
        audience: "For companies, guilds and institutions",
        title: "Missions, fairs and destination representation",
        subtitle: "Strategy operated on the ground to promote, commercialize and learn.",
        description: "For companies, guilds and institutions that want to enter a new market, consolidate an existing one or attract tourism to their destination. We design and operate the full mission, fair representation or just the strategic part — you choose how far we go.",
        anti: "Not institutional trips. Strategies with results you can actually report.",
        benefits_label: "What you get",
        benefits: [
          "Real market entry — meetings with decision-makers, not intermediaries",
          "Direct promotion and commercialization of your destination, product or guild",
          "Technical visits to industry leaders — learning on the ground",
          "Stand operation and representation at international fairs",
          "Networking with wholesalers, authorities and partners that move the needle",
          "Executive report with contacts, findings and actionable opportunities",
        ],
        operation_label: "How we operate",
        operation: [
          "You decide how far we go: just the agenda, stand operation, or agenda + full logistics (flights, lodging, transfers, facilitation, PR, activations).",
          "Creative concept, activations, public relations and institutional agendas — everything a destination or company needs to stand out.",
          "End-to-end coordination — you don't chase anyone.",
        ],
        flagship_label: "Flagship product",
        flagship: "Academic missions with real immersion: your team learns inside leading companies, destinations and operations — with sector experts facilitating each visit. No lectures, no auditoriums. Learning on the ground.",
        types_label: "Three mission types",
        types: [
          {
            code: "01",
            name: "Commercial",
            tag: "B2B · Markets",
            description: "Missions to connect your company or guild with markets, distributors, wholesalers and strategic partners. Real meetings with decision-makers — not with intermediaries.",
            cta: "Design commercial mission",
          },
          {
            code: "02",
            name: "Academic",
            tag: "Immersion · Learning",
            description: "Your team learns inside leading companies, destinations and operations — with sector experts facilitating each visit. Learning on the ground, not in auditoriums.",
            cta: "Design academic mission",
            flagship: true,
          },
          {
            code: "03",
            name: "Technical",
            tag: "Innovation · Benchmarks",
            description: "Technical missions to see first-hand how industry leaders operate in innovation, infrastructure, applied technology and new business models.",
            cta: "Design technical mission",
          },
        ],
        formats_label: "Formats",
        formats: ["Commercial", "Academic", "Technical", "Corporate", "International fairs", "Destination representation"],
        events_label: "We have operated at",
        events: [
          "Tianguis Turístico — Mexico",
          "FITUR — Madrid, Spain",
          "IBTM Américas — Mexico",
          "ITB — Berlin, Germany",
          "Convening Latam",
          "WTM — London, United Kingdom",
        ],
        results_label: "Results we deliver",
        results: [
          "+15 business meetings per invited actor",
          "Meetings with European, Mexican and Colombian authorities",
          "Wholesalers, high-level companies and strategic partners at the table",
          "Real market entry — not just presence at the booth",
        ],
        cta: "Design my mission",
      },
      transformadoras: {
        tag: "Line 02",
        audience: "For teams, leaders and entrepreneurs",
        title: "Transformative Experiences",
        subtitle: "For when your team, your leadership or you need to stop and return with clarity.",
        description: "When decisions have been pending for months, the team is worn out, or leadership needs space. We design retreats that combine territory, nature and expert facilitation — and that you can feel upon return.",
        anti: "Not just another wellness retreat. A turning point.",
        benefits_label: "What you get",
        benefits: [
          "A space designed to make the decision you've been postponing",
          "Real reconnection with your team — not Instagram-worthy activities",
          "Facilitators with proven experience, not motivational speakers",
          "Nature and experiences your team will remember for years",
          "A more aligned team with new energy upon return",
        ],
        operation_label: "How we operate",
        operation: [
          "Initial conversation to understand the moment you or your team are in.",
          "100% tailor-made design: place, agenda, facilitators, pace.",
          "Support throughout the entire experience — no surprises.",
        ],
        formats_label: "Approaches",
        formats: ["Leadership", "Wellness", "Nature", "Co-creation", "Reflection"],
        cta: "Design my experience",
      },
      curados: {
        tag: "Line 03",
        audience: "For travelers with criteria",
        title: "Tailor-made journeys",
        subtitle: "For travelers who already did the typical tour and now want something worth their time.",
        description: "We design with you a journey that combines culture, nature, gastronomy, art or heritage — with hosts, places and experiences that don't appear in search engines. Your agenda, your pace, your real interests.",
        anti: "We don't sell packages. Each trip is designed with you.",
        benefits_label: "What you get",
        benefits: [
          "A trip made to your measure, with details only a local truly understands",
          "Access to hosts, chefs and artists you won't find online",
          "Zero queues, zero tourist buses, zero 'mandatory shop' stops",
          "A dedicated person who knows your trip in detail",
          "The feeling of having seen the destination from the inside, not in passing",
        ],
        operation_label: "How we operate",
        operation: [
          "Initial call to understand what really excites you.",
          "Personalized proposal with itinerary, alternatives and clear budget.",
          "Full coordination from your home back to your home.",
        ],
        formats_label: "Universes",
        formats: ["Culture", "Nature", "Gastronomy", "Art", "Heritage"],
        cta: "Design my journey",
      },
    },
    marketplace: {
      eyebrow: "Coming soon",
      title: "A marketplace of experiences and partners, in construction.",
      lead: "We're building a space connecting travelers, companies and partners with experiences we already know, have tested and back.",
      categories_title: "What you'll find",
      categories: [
        { title: "Missions", desc: "Professional experiences with designed agenda." },
        { title: "Transformative experiences", desc: "Retreats and programs with purpose." },
        { title: "Tailor-made journeys", desc: "Private itineraries, made with you." },
        { title: "Local partners", desc: "Operators, hosts and specialists we know in person." },
        { title: "Experiences by destination", desc: "Routes and programs by territory." },
        { title: "Corporate programs", desc: "Designed for teams and institutions." },
      ],
      cta_primary: "I want to see available experiences",
      cta_secondary: "I want to become a partner",
      note: "Each category will fill with experiences and partners we know in person. No generic catalogs.",
    },
    diferencial: {
      eyebrow: "Why us",
      title: "We know the ground.",
      lead: "Incubatour Experiences Lab grows from over 25 years of experience supporting tourism transformation in Ibero-America through consulting, innovation and experience design.",
      body: "Over 25 years we have operated more than 570 missions, fairs and destination representations with companies, institutions and guilds. We know what works and what doesn't — because we have seen it happen on the ground. We don't sell catalog: we test, validate and operate each mission with our own team.",
      points: [
        "Real experience on the ground — not from a desk",
        "Deep tourism ecosystem knowledge",
        "Network of partners in Latin America and Europe",
        "Strategic vision, not only operational",
        "Selection rooted in trust and purpose",
        "Applied AI: matchmaking, lead generation, analytics and real-time reports",
      ],
      metrics: [
        { value: "+570", unit: "events", label: "operated in Ibero-America · fairs, congresses, missions and training events" },
        { value: "+25", unit: "years", label: "supporting the tourism sector in Ibero-America" },
        { value: "+100", unit: "", label: "tourism products designed, validated or advised" },
        { value: "RNT", unit: "278668", label: "Legal operation in Colombia · Latin America and Europe" },
      ],
      clients_eyebrow: "Trusted by",
      clients: [
        "Anato — Capítulo Eje Cafetero",
        "ProColombia",
        "Secretaría de Turismo de Michoacán",
        "Buró de Medellín",
        "Comfama",
        "Alcaldía de Pereira",
        "Alcaldía de Santa Rosa de Cabal",
      ],
    },
    cobertura: {
      eyebrow: "International markets operated",
      title: "We design where we truly know.",
      lead: "We don't sell destinations randomly. We activate experiences where we have a team, partners and first-hand knowledge. We have operated in 8 key markets to connect Ibero-America with the world.",
      markets_label: "Markets we have worked in",
      markets: [
        { code: "MX", name: "Mexico" },
        { code: "ES", name: "Spain" },
        { code: "DE", name: "Germany" },
        { code: "UK", name: "United Kingdom" },
        { code: "SV", name: "El Salvador" },
        { code: "UY", name: "Uruguay" },
        { code: "PA", name: "Panama" },
        { code: "EC", name: "Ecuador" },
      ],
      fairs_label: "Fairs and events we have operated",
      fairs: [
        "Tianguis Turístico — Mexico",
        "FITUR — Madrid, Spain",
        "IBTM Américas — Mexico",
        "ITB — Berlin, Germany",
        "Convening Latam",
        "WTM — London, United Kingdom",
      ],
      destinations: [
        { code: "CO", name: "Colombia", note: "Headquarters · home territory" },
        { code: "MX", name: "Mexico", note: "Culture, gastronomy and community" },
        { code: "ES", name: "Spain", note: "Bridge Europe–Ibero-America" },
        { code: "GL", name: "Global expeditions", note: "With trusted partners" },
      ],
    },
    proceso: {
      eyebrow: "DMC guarantees",
      title: "This is why we are a DMC, not an agency.",
      steps: [
        { n: "01", t: "Our own team in each destination", d: "We operate directly in Colombia, Mexico and Spain with our own people. No cold subcontractors." },
        { n: "02", t: "Network vetted in person", d: "Lodging, transfers and partners proven across +570 events. Not a catalog." },
        { n: "03", t: "Fully legal operation", d: "RNT 278668, insurance, contracts and end-to-end financial traceability." },
        { n: "04", t: "Executive post-trip report", d: "Outcomes, contacts and actionable learnings so your investment leaves a mark." },
      ],
    },
    audiencia: {
      eyebrow: "Who we work with",
      title: "Three worlds, the same care.",
      list: [
        { t: "Companies with purpose", d: "Looking for corporate journeys with real impact — not just events." },
        { t: "Institutions and guilds", d: "That need technical, commercial or academic missions with results." },
        { t: "Leaders and entrepreneurs", d: "Seeking clarity, well-being and vision through territory." },
        { t: "Travelers with criteria", d: "Who prefer authentic, deep experiences over generic packages." },
        { t: "Communities and destinations", d: "Wanting to connect their offer with audiences that truly value it." },
      ],
    },
    finalCta: {
      eyebrow: "Let's start",
      title: "Tell us what mission you want to design.",
      sub: "A commercial, academic or technical mission. A fair. Destination representation. We turn your intent into a strategy operated on the ground.",
      primary: "Talk on WhatsApp",
      secondary: "See what we do",
      footnote: "Based in Colombia · RNT 278668 · An Incubatour initiative",
    },
    footer: {
      tagline: "We design and operate missions, fairs and destination representation across Ibero-America.",
      nav_title: "Navigate",
      legal_title: "Legal",
      contact_title: "Contact",
      copyright: "© {year} Incubatour Experiences Lab. An Incubatour initiative.",
      rnt: "RNT 278668",
      privacy: "Privacy",
      terms: "Terms",
      social: "Social",
    },
    forms: {
      contact_title: "Let's design your mission",
      contact_sub: "Tell us what you need. We respond within 24 business hours.",
      referral_title: "I want to become a partner",
      referral_sub: "Share your proposal. We get to know each partner before recommending them.",
      name: "Full name",
      email: "Email",
      phone: "Phone or WhatsApp",
      organization: "Organization",
      interest: "What are you interested in?",
      interest_options: {
        mision: "Mission",
        transformadora: "Transformative experience",
        curado: "Tailor-made journey",
        aliado: "Become a partner",
        general: "Other inquiry",
      },
      category: "Category",
      category_options: {
        experiencia: "Experience",
        aliado: "Partner / Operator",
        proveedor: "Specialist provider",
        destino: "Destination / Territory",
      },
      territory: "Territory or destination",
      website: "Website (optional)",
      message: "Tell us your intent",
      description: "Describe your proposal",
      submit: "Send",
      sending: "Sending…",
      success: "Message received. We'll be in touch shortly.",
      success_referral: "Proposal received. We'll review it with attention.",
      error: "Something went wrong. Please retry or message us on WhatsApp.",
    },
  },
};

export const useT = (locale) => {
  const d = dict[locale] || dict.es;
  const t = (path) => {
    const parts = path.split(".");
    let cur = d;
    for (const p of parts) {
      if (cur == null) return path;
      cur = cur[p];
    }
    return cur ?? path;
  };
  return { t, d };
};
